import {
    IonGrid,
    IonCol,
    IonRow,
    IonContent,
    IonHeader,
    IonIcon,
    IonText,
    IonPage,  
    useIonViewWillEnter,
    isPlatform,
    IonList,
    IonItem,
    IonLabel,
    IonModal,
    IonToolbar,
    IonTitle,
    IonButton,
    IonButtons} from '@ionic/react';
import { settingsSharp, addCircle, helpCircleOutline, logoYoutube, close } from 'ionicons/icons';
import { ReactComponent as PrayerIcon } from '../../assets/images/prayerLogo.svg';
import './PrayerPage.scss';
import React, { useContext, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { useHistory } from 'react-router-dom';
import IPrayerSettings from '../../interfaces/IPrayerSettings';
import PrayerSettingsService from '../../services/PrayerSettingsService';
import NoSleepContext from '../../components/NoSleepContext/NoSleepContext';
import { DefaultPrayerSettings } from '../../data/DefaultPrayerSettings';
import { InsomniaOriginal } from '@awesome-cordova-plugins/insomnia';
import NoSleep from 'nosleep.js';
import BibleVideos from '../../components/BibleVideos/BibleVideos';
import { ISessionVideo } from '../../interfaces/ISessionVideo';
import VideoTypes from '../../data/VideoTypes';
import DismissibleCard from '../../components/DismissibleCard/DismissibleCard';
import { AppMessages } from '../../data/AppMessages';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import IDismissibleMessage from '../../interfaces/IDismissibleMessage';
  
  const Prayer: React.FC<IRouteInfo> = (props) => {
    const history = useHistory();
    const [prayerSettings, setPrayerSettings] = useState<IPrayerSettings | undefined>(undefined);
    const [showTutorialModal, setShowTutorialModal] = useState(false);
    const [tutorialVideo, setTutorialVideo] = useState<ISessionVideo[] | undefined>(undefined);
    const [hideDismissibleMessage, setHideDismissibleMessage] = useState(false);
    const noSleep = useContext(NoSleepContext);

    useIonViewWillEnter(() => {
      loadPrayerSettings();
    });

    const loadPrayerSettings = async () => {
      await PrayerSettingsService.getPrayerSettings().then(response => {
        if(response.Success && response.Data) {
          setPrayerSettings(response.Data!)
        }
        else {
          setPrayerSettings(DefaultPrayerSettings);
        }
      });
    };

    const enableNoSleep = () => {
      if(isPlatform('hybrid')) {
        const awake = noSleep as InsomniaOriginal;
        awake?.keepAwake();
      } else if (!isPlatform('ios')) {
        const awake = noSleep as NoSleep;
        awake?.enable();
      } 
    }

    const openPrayerTutorial = (type: string) => {
      const videoSettings: ISessionVideo = {
        title: 'Get Started Prayer Guide',
        videoType: VideoTypes.youtube,
        code: 'Bqs09tPC7Bg',
        vertical: true,
      }

      switch (type) {
        case 'getStarted':
          // values already set for getting started
          break;
        case 'managePrayers':
          videoSettings.title = 'Manage Your Prayers';
          videoSettings.startTime=28;
          break;
        case 'prayerSettings':
          videoSettings.title = 'Prayer Settings Guide';
          videoSettings.startTime = 130;
          break;
        case 'prayNow':
          videoSettings.title = 'Pray Now Guide';
          videoSettings.startTime = 224;
          break;
        default:
          break;
      }
      setTutorialVideo([videoSettings]);
      setShowTutorialModal(true);
    }

    const dismissMessage = (messageId: string, initiateAction: boolean) => {
      const dismissMessage: IDismissibleMessage = {
        messageId,
        category: props.title,
        timesDisplayed: 1,
        dateDisplayed: new Date(Date.now()),
        dismissed: true,
      }
      DismissibleMessageService.logDismissibleMessage(dismissMessage);
      setHideDismissibleMessage(true);

      if(initiateAction) {
        openPrayerTutorial('getStarted');
      }
    }

    const pageHeaderMenuContent = 
    <IonList className="prayer-page-menu-list">
      <IonItem className="header-menu-item" onClick={() => openPrayerTutorial('getStarted')}>
        <IonLabel>Get Started Guide</IonLabel>
        <IonIcon slot="end" icon={logoYoutube}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={() => openPrayerTutorial('managePrayers')}>
        <IonLabel>Managing Prayers Guide</IonLabel>
        <IonIcon slot="end" icon={logoYoutube}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={() => openPrayerTutorial('prayerSettings')}>
        <IonLabel>Prayer Settings Guide</IonLabel>
        <IonIcon slot="end" icon={logoYoutube}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={() => openPrayerTutorial('prayNow')}>
        <IonLabel>Pray Now Guide</IonLabel>
        <IonIcon slot="end" icon={logoYoutube}></IonIcon>
      </IonItem>
    </IonList>;

    return (
      <IonPage>
        <IonHeader>
        <PageHeader {...props} menuContents={pageHeaderMenuContent} menuIcon={helpCircleOutline}></PageHeader>
        </IonHeader>
        <IonContent color="prayer-shade">
          <DismissibleCard
            messageId={AppMessages.prayerTutorial.messageId}
            hideCard={hideDismissibleMessage}
            buttonText="Watch Prayer Guide Now!"
            color="prayer"
            dismissCard={dismissMessage}
          >
            {AppMessages.prayerTutorial.messageBody}
          </DismissibleCard>
          <IonGrid fixed={true}>
            <IonRow className="ion-text-center">
              <IonCol>
                <PrayerIcon className="color-secondary large-size-now-button icon-glow"
                  onClick={() => {
                    if(!!prayerSettings?.showSettings) {
                      history.push(AppRouteInfo[AppRouteKeys.PrayerSessionSettings].path, {direction: 'forward'});
                    } else {
                      enableNoSleep();
                      history.push(AppRouteInfo[AppRouteKeys.PrayNow].path, {direction: 'forward'});
                    }
                  }} />
                <IonText color="secondary" className="prayer-button-label">PRAY NOW</IonText>
              </IonCol>
            </IonRow>
            <IonRow className="ion-text-center">
              <IonCol>
                <IonIcon icon={AppRouteInfo[AppRouteKeys.MyPrayers].icon} className="color-secondary medium-size-prayer-button icon-glow" 
                  onClick={() => history.push(AppRouteInfo[AppRouteKeys.MyPrayers].path, {direction: 'forward'})}></IonIcon>
                <IonText color="secondary" className="prayer-button-label">MY PRAYERS</IonText>
              </IonCol>
              <IonCol>
                <IonIcon icon={addCircle} className="color-secondary medium-size-prayer-button icon-glow"
                  onClick={() => history.push(AppRouteInfo[AppRouteKeys.PrayerUpdate].path.replace(':id', 'new'), {direction: 'forward'})}></IonIcon>
                <IonText color="secondary" className="prayer-button-label">ADD PRAYER</IonText>
              </IonCol>
            </IonRow>
            <IonRow className="ion-text-center">
              <IonCol>
                <IonIcon icon={settingsSharp} className="color-secondary medium-size-prayer-button icon-glow"
                  onClick={() => history.push(AppRouteInfo[AppRouteKeys.PrayerSessionSettings].path, {direction: 'forward'})}></IonIcon>
                <IonText color="secondary" className="prayer-button-label">PRAYER SETTINGS</IonText>
              </IonCol>
            </IonRow>
          </IonGrid>
          <IonModal
            isOpen={showTutorialModal}
            onDidDismiss={() => setShowTutorialModal(false)}
            breakpoints={isPlatform("mobile") ? undefined : [0, 0.5, 0.75, 1]}
            initialBreakpoint={isPlatform("mobile") ? undefined : 1}
            mode='md'
            className='prayer-video-tutorial-modal'
            canDismiss={true}>
            <IonContent>
              <IonHeader>
                <IonToolbar>
                  <IonTitle>Prayer Tutorials</IonTitle>
                  <IonButtons slot="end">
                    <IonButton onClick={() => setShowTutorialModal(false)} >
                      <IonIcon slot="icon-only" icon={close}/>
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <BibleVideos videos={tutorialVideo}></BibleVideos>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonContent>
          </IonModal>
        </IonContent>
      </IonPage>
    );
  };
  
  export default Prayer;
  